import { GridColDef } from "@mui/x-data-grid";
import dayjs from "dayjs";
import { useCallback } from "react";
import api, { RetailerVendorDto, RetailerVendorSettingsSchedulerMode, RetailerVendorSettingsSendMethod } from "../../../api";
import { PaginatedDataGrid, PaginationData } from "../../controls";

export interface RetailerVendorsGridProps {
  retailerId?: string;
  onRowSelected?: (row: RetailerVendorDto | null) => void;
  onRowDoubleClick?: (row: RetailerVendorDto | null) => void;
}

export const RetailerVendorsGrid = (props: RetailerVendorsGridProps) => {
  const { retailerId, onRowSelected, onRowDoubleClick } = props;

  const loadData = useCallback(async (page: number, size: number, sort: string, filter: string): Promise<PaginationData<RetailerVendorDto>> => {
    if (retailerId) {
      return await api.retailerVendor.find({ page, size, sort, retailerId, name: filter } as any);
    }
    return { data: [], count: 0 } as any;
  }, [retailerId]);

  const columns: GridColDef<RetailerVendorDto>[] = [
    { field: "retailer.name", headerName: "Retailer", minWidth: 50, flex: 200, editable: false, sortable: true, filterable: false, valueGetter: (p) => p.row.retailer?.name || "" },
    { field: "vendor.name", headerName: "Vendor", minWidth: 50, flex: 200, editable: false, sortable: true, filterable: false, valueGetter: (p) => `${p.row.vendor?.name}${p.row.vendor?.isEnabled === false ? ' (disabled)' : ''}` || "" },
    { field: "isEnabled", headerName: "Enabled", width: 70, editable: false, sortable: true, filterable: false, align: "center", headerAlign: "center", valueFormatter: (p) => (p.value ? "Yes" : "No") },
    { field: "scheduler", headerName: "Scheduler", width: 80, editable: false, sortable: false, filterable: false, align: "center", headerAlign: "center", valueGetter: (p) => (p.row.settings?.schedulerMode ?? RetailerVendorSettingsSchedulerMode.System) },
    { field: "method", headerName: "Method", width: 80, editable: false, sortable: false, filterable: false, align: "center", headerAlign: "center", valueGetter: (p) => (p.row.settings?.sendMethod ?? RetailerVendorSettingsSendMethod.None) },
    { field: "lastSendAt", headerName: "Sent", width: 150, editable: false, sortable: true, filterable: false, valueFormatter: (p) => dayjs(p.value).format("YYYY-MM-DD HH:mm:ss") },
    { field: "createdAt", headerName: "Created", width: 150, editable: false, sortable: true, filterable: false, valueFormatter: (p) => dayjs(p.value).format("YYYY-MM-DD HH:mm:ss") },
  ];

  return <PaginatedDataGrid name="RetailerVendors" loadData={loadData} columns={columns} showFilter onRowSelected={onRowSelected} onRowDoubleClick={onRowDoubleClick} getRowId={(row) => `${row?.retailerId};${row?.vendorId}` }/>;
};
